import React, { PureComponent } from "react";
import Spinner from "../components/@vuexy/spinner/Fallback-spinner";
import { Helmet } from "react-helmet";
import { IntlProviderWrapper } from "../utility/context/Internationalization";
import putScript from "../utility/useScript";
// import jQuery from '../assets/static'

class WebsiteLayout extends PureComponent {
  constructor(props) {
    super(props);
    this.handleLoad = this.handleLoad.bind(this);
  }

  state = {
    loading: true,
  };

  componentDidMount() {
    document.body.classList.add("website");
    document.getElementsByTagName("html")[0].setAttribute("dir", "rtl");
    // window.addEventListener('load', this.handleLoad);

    putScript("assets/js/jquery-3.3.1.min.js", ["/", "/AdmissionReq", "/applicant", "/page"]);
    putScript("assets/js/jquery.themepunch.revolution.min.js", [
      "/",
      "/AdmissionReq",
      "/applicant",
      "/page",
    ]);
    this.handleLoad();
  }

  componentWillUnmount() {
    //    window.removeEventListener('load', this.handleLoad)
  }

  handleLoad() {
    this.setState({
      loading: false,
    });
  }
  render() {
    return this.state.loading ? null : (
      <IntlProviderWrapper>
        <div className={`${this.state.loading ? "d-block" : "d-none"}`}>
          <Spinner />
        </div>
        <div className={`${this.state.loading ? "d-none" : "d-block"}`}>
          <Helmet
            script={[
              { type: "text/javascript", src: "assets/js/swiper.min.js" },
              { type: "text/javascript", src: "assets/js/bootstrap.min.js" },
              { type: "text/javascript", src: "assets/js/venobox.min.js" },
              { type: "text/javascript", src: "assets/js/owl.carousel.js" },
              { type: "text/javascript", src: "assets/js/jquery.nice-select.min.js" },
              { type: "text/javascript", src: "assets/js/modernizr.js" },
              { type: "text/javascript", src: "assets/js/jquery.themepunch.tools.min.js" },
              { type: "text/javascript", src: "assets/js/jquery.countTo.js" },
              { type: "text/javascript", src: "assets/js/jquery.inview.min.js" },
              { type: "text/javascript", src: "assets/js/jquery.menu-aim.js" },
              { type: "text/javascript", src: "assets/js/revolution.extension.slideanims.min.js" },
              { type: "text/javascript", src: "assets/js/revolution.extension.actions.min.js" },
              { type: "text/javascript", src: "assets/js/revolution.extension.carousel.min.js" },
              {
                type: "text/javascript",
                src: "assets/js/revolution.extension.layeranimation.min.js",
              },
              { type: "text/javascript", src: "assets/js/revolution.extension.migration.min.js" },
              { type: "text/javascript", src: "assets/js/revolution.extension.kenburn.min.js" },
              { type: "text/javascript", src: "assets/js/revolution.extension.navigation.min.js" },
              { type: "text/javascript", src: "assets/js/revolution.extension.parallax.min.js" },
              { type: "text/javascript", src: "assets/js/revolution.extension.video.min.js" },
            ]}
          >
            <link rel="stylesheet" type="text/css" href="assets/css/animate.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/bootstrap.min.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/fonts.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/font-awesome.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/nice-select.css" />

            <link rel="stylesheet" type="text/css" href="assets/css/settings.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/book.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/swiper.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/venobox.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/testimonial.css" />

            <link rel="stylesheet" type="text/css" href="assets/css/flaticon.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/owl.carousel.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/owl.theme.default.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/settings.css" />
            {/* <link rel="stylesheet" type="text/css" href="assets/css/layers.css" /> */}

            <link rel="stylesheet" type="text/css" href="assets/css/navigation.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/style_II.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/style-rtl.css" />
            <link rel="stylesheet" type="text/css" href="assets/css/responsive_II.css" />

            <link rel="stylesheet" type="text/css" href="assets/css/kafaa_style.css" />
          </Helmet>
          <div className="App" style={{ fontSize: "16px" }}>
            {this.props.children}
          </div>
        </div>
      </IntlProviderWrapper>
    );
  }
}

export default WebsiteLayout;
